import React from 'react';
import { Pill } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../ui/table';
import { formatCurrency } from '../../lib/utils';

// Conversiones de unidades
const UNIT_CONVERSIONS = {
  'kg': { 'kg': 1, 'lb': 2.20462, 'gramo': 1000, 'mg': 1000000 },
  'lb': { 'kg': 0.453592, 'lb': 1, 'gramo': 453.592, 'mg': 453592 },
  'gramo': { 'kg': 0.001, 'lb': 0.00220462, 'gramo': 1, 'mg': 1000 },
  'mg': { 'kg': 0.000001, 'lb': 0.00000220462, 'gramo': 0.001, 'mg': 1 },
  'litro': { 'litro': 1, 'ml': 1000 },
  'ml': { 'litro': 0.001, 'ml': 1 },
};

export function PremixTable({ premixMedications }) {
  return (
    <Card className="border-slate-200">
      <CardHeader className="border-b border-slate-100">
        <CardTitle className="flex items-center gap-2">
          <Pill className="h-5 w-5 text-purple-600" />
          Medicamentos Premix
        </CardTitle>
        <p className="text-sm text-slate-500">
          Medicamentos tipo premix disponibles para agregar a las fórmulas de alimento
        </p>
      </CardHeader>
      <CardContent className="p-0">
        {premixMedications.length === 0 ? (
          <div className="p-8 text-center text-slate-500">
            <Pill className="h-12 w-12 mx-auto mb-4 text-slate-300" />
            <p className="font-medium">No hay medicamentos premix registrados</p>
            <p className="text-sm mt-1">Ve a Medicamentos y crea uno con tipo de administración "Premix"</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="bg-slate-50">
                <TableHead>Medicamento</TableHead>
                <TableHead>Categoría</TableHead>
                <TableHead>Presentación</TableHead>
                <TableHead className="text-right">Stock</TableHead>
                <TableHead className="text-right">Precio Unit.</TableHead>
                <TableHead className="text-right">Valor Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {premixMedications.map((med) => {
                // Calcular stock en unidad base y en lb
                const stockInBaseUnit = med.current_stock * (med.presentation_quantity || 1);
                const stockInLb = stockInBaseUnit * (UNIT_CONVERSIONS[med.unit]?.['lb'] || 1);
                const stockInKg = stockInBaseUnit * (UNIT_CONVERSIONS[med.unit]?.['kg'] || 1);
                // Calcular valor total del stock
                const totalValueUSD = med.current_stock * (med.price_usd || 0);
                const totalValueDOP = med.current_stock * (med.price_dop || 0);
                
                return (
                  <TableRow key={med.id}>
                    <TableCell>
                      <div>
                        <p className="font-medium">{med.name}</p>
                        <span className="inline-flex items-center px-2 py-0.5 rounded bg-purple-100 text-purple-700 text-xs font-medium">
                          Premix
                        </span>
                      </div>
                    </TableCell>
                    <TableCell>{med.category}</TableCell>
                    <TableCell>
                      {med.presentation} 
                      {med.presentation_quantity > 0 && (
                        <span className="text-slate-500"> ({med.presentation_quantity} {med.unit})</span>
                      )}
                    </TableCell>
                    <TableCell className="text-right">
                      <div>
                        <p className="font-semibold">{parseFloat(med.current_stock).toFixed(4)} {med.presentation}</p>
                        {med.presentation_quantity > 0 && (
                          <p className="text-xs text-purple-600">
                            = {stockInKg.toFixed(2)} kg / {stockInLb.toFixed(2)} lb
                          </p>
                        )}
                      </div>
                    </TableCell>
                    <TableCell className="text-right">
                      <div>
                        <p className="font-semibold">{formatCurrency(med.price_usd, 'USD')}/{med.presentation}</p>
                        <p className="text-sm text-green-600">({formatCurrency(med.price_dop)}/{med.presentation})</p>
                      </div>
                    </TableCell>
                    <TableCell className="text-right">
                      <div>
                        <p className="font-bold text-[#931A25]">{formatCurrency(totalValueUSD, 'USD')}</p>
                        <p className="text-sm text-blue-600">({formatCurrency(totalValueDOP)})</p>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
